// メーカーラベル
const gorillaLabelOutline1 = (ctx: CanvasRenderingContext2D, x: number, y: number): void => {
  ctx.lineWidth = 1.5
  ctx.strokeStyle = '#363636'
  // 輪郭
  ctx.beginPath()
  ctx.fillStyle = '#5F4137'
  ctx.moveTo(310 + x, 560 + y) //
  ctx.quadraticCurveTo(310 + x, 574 + y, 328 + x, 584 + y) //  真ん中中央
  ctx.quadraticCurveTo(348 + x, 591 + y, 373 + x, 580 + y) //  アゴ右下
  ctx.quadraticCurveTo(415 + x, 577 + y, 424 + x, 547 + y) //  右下
  ctx.quadraticCurveTo(397 + x, 503 + y, 381 + x, 497 + y) //  帽子＿右下
  ctx.quadraticCurveTo(359 + x, 488 + y, 345 + x, 490 + y) //  帽子＿左下
  ctx.quadraticCurveTo(337 + x, 493 + y, 335 + x, 506 + y) //
  ctx.quadraticCurveTo(333 + x, 512 + y, 324 + x, 514 + y) //
  ctx.quadraticCurveTo(320 + x, 518 + y, 323 + x, 529 + y) //
  ctx.quadraticCurveTo(324 + x, 536 + y, 321 + x, 540 + y) // 鼻＿左上
  ctx.quadraticCurveTo(309 + x, 545 + y, 310 + x, 560 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const gorillaLabelFace1 = (ctx: CanvasRenderingContext2D, x: number, y: number): void => {
  ctx.lineWidth = 1.5
  ctx.strokeStyle = '#363636'
  // 輪郭
  ctx.beginPath()
  ctx.fillStyle = '#FFB57C'
  ctx.moveTo(310 + x, 560 + y) //
  ctx.quadraticCurveTo(310 + x, 574 + y, 328 + x, 584 + y) //  真ん中中央
  ctx.quadraticCurveTo(348 + x, 591 + y, 373 + x, 580 + y) //  アゴ右下
  ctx.quadraticCurveTo(393 + x, 570 + y, 386 + x, 553 + y) //
  ctx.quadraticCurveTo(380 + x, 542 + y, 371 + x, 545 + y) //
  ctx.quadraticCurveTo(367 + x, 540 + y, 371 + x, 535 + y) //
  ctx.quadraticCurveTo(375 + x, 521 + y, 360 + x, 514 + y) //
  ctx.quadraticCurveTo(349 + x, 508 + y, 336 + x, 525 + y) //
  ctx.quadraticCurveTo(331 + x, 527 + y, 331 + x, 522 + y) //
  ctx.quadraticCurveTo(330 + x, 515 + y, 328 + x, 515 + y) //
  ctx.quadraticCurveTo(320 + x, 518 + y, 323 + x, 529 + y) //
  ctx.quadraticCurveTo(324 + x, 536 + y, 321 + x, 540 + y) // 鼻＿左上
  ctx.quadraticCurveTo(309 + x, 545 + y, 310 + x, 560 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 耳
  ctx.beginPath()
  ctx.strokeStyle = '#363636'
  ctx.moveTo(379 + x, 540 + y) //
  ctx.quadraticCurveTo(391 + x, 543 + y, 389 + x, 532 + y) //
  ctx.quadraticCurveTo(386 + x, 525 + y, 381 + x, 529 + y) //
  ctx.quadraticCurveTo(379 + x, 532 + y, 379 + x, 540 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const gorillaFaceParts = (ctx: CanvasRenderingContext2D, x: number, y: number): void => {
  ctx.fillStyle = '#363636'
  ctx.strokeStyle = '#363636'
  // 口
  ctx.beginPath()
  ctx.moveTo(314 + x, 555 + y) //
  ctx.quadraticCurveTo(310 + x, 565 + y, 323 + x, 570 + y) //  真ん中中央
  ctx.quadraticCurveTo(346 + x, 576 + y, 365 + x, 563 + y) //
  ctx.moveTo(363 + x, 555 + y) //
  ctx.quadraticCurveTo(362 + x, 564 + y, 370 + x, 565 + y) //  真ん中中央
  ctx.stroke()
  ctx.closePath()

  // 鼻
  ctx.beginPath()
  ctx.moveTo(321 + x, 545 + y) //
  ctx.quadraticCurveTo(325 + x, 555 + y, 336 + x, 548 + y) //
  ctx.quadraticCurveTo(336 + x, 544 + y, 329 + x, 543 + y) //
  ctx.quadraticCurveTo(322 + x, 542 + y, 321 + x, 545 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 目
  ctx.beginPath()
  ctx.moveTo(328 + x, 536 + y)
  ctx.arc(328 + x, 536 + y, 2, 0, 2 * Math.PI)
  ctx.moveTo(347 + x, 538 + y)
  ctx.arc(347 + x, 538 + y, 3, 0, 2 * Math.PI)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 眉毛
  // ctx.strokeStyle = 'red'
  ctx.beginPath()
  ctx.moveTo(324 + x, 529 + y) //
  ctx.quadraticCurveTo(323 + x, 523 + y, 326 + x, 524 + y) //
  ctx.quadraticCurveTo(329 + x, 524 + y, 331 + x, 528 + y) //
  ctx.quadraticCurveTo(336 + x, 536 + y, 340 + x, 527 + y) //
  ctx.quadraticCurveTo(350 + x, 517 + y, 361 + x, 525 + y) //
  ctx.quadraticCurveTo(366 + x, 528 + y, 363 + x, 532 + y) //
  ctx.quadraticCurveTo(359 + x, 525 + y, 352 + x, 524 + y) //
  ctx.quadraticCurveTo(346 + x, 523 + y, 339 + x, 532 + y) //
  ctx.quadraticCurveTo(332 + x, 536 + y, 330 + x, 529 + y) //
  ctx.quadraticCurveTo(326 + x, 525 + y, 326 + x, 525 + y) //
  ctx.quadraticCurveTo(324 + x, 529 + y, 324 + x, 529 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const gorillaCap = (ctx: CanvasRenderingContext2D, x: number, y: number): void => {
  // 裏
  ctx.strokeStyle = '#363636'
  ctx.fillStyle = '#eee'
  ctx.beginPath()
  ctx.moveTo(346 + x, 484 + y) //
  ctx.quadraticCurveTo(335 + x, 483 + y, 329 + x, 490 + y) //
  ctx.quadraticCurveTo(330 + x, 493 + y, 340 + x, 494 + y) // 右下
  ctx.quadraticCurveTo(343 + x, 489 + y, 348 + x, 490 + y) //
  ctx.quadraticCurveTo(360 + x, 489 + y, 360 + x, 489 + y) //
  ctx.quadraticCurveTo(346 + x, 484 + y, 346 + x, 484 + y) //
  ctx.moveTo(336 + x, 488 + y) //
  ctx.quadraticCurveTo(345 + x, 489 + y, 346 + x, 490 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 表
  ctx.fillStyle = '#0094E8'
  ctx.beginPath()
  ctx.moveTo(347 + x, 485 + y) //
  ctx.quadraticCurveTo(362 + x, 490 + y, 362 + x, 490 + y) //
  ctx.quadraticCurveTo(381 + x, 496 + y, 381 + x, 496 + y) //
  ctx.quadraticCurveTo(382 + x, 485 + y, 376 + x, 483 + y) //
  ctx.quadraticCurveTo(365 + x, 473 + y, 352 + x, 477 + y) //
  ctx.quadraticCurveTo(347 + x, 478 + y, 347 + x, 485 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const gorillaLabelHead = (ctx: CanvasRenderingContext2D, x: number, y: number, numerator: number, scaleSize: number): void => {
  ctx.save()
  ctx.rotate((numerator * Math.PI) / 180)
  ctx.scale(scaleSize, scaleSize)
  gorillaLabelOutline1(ctx, x, y)
  gorillaLabelFace1(ctx, x, y)
  gorillaFaceParts(ctx, x, y)
  gorillaCap(ctx, x, y)
  ctx.restore()
}

const gorillaLabelBody = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number
  // numerator: number,
  // scaleSize: number
): void => {
  ctx.lineWidth = 1.0
  // ctx.save()
  // ctx.rotate((numerator * Math.PI) / 180)
  // ctx.scale(scaleSize, scaleSize)
  ctx.strokeStyle = '#363636'
  ctx.fillStyle = '#eee'
  ctx.beginPath()
  ctx.moveTo(343 + x, 541 + y) //
  ctx.quadraticCurveTo(341 + x, 544 + y, 341 + x, 544 + y) //
  ctx.quadraticCurveTo(344 + x, 544 + y, 347 + x, 551 + y) //
  ctx.quadraticCurveTo(348 + x, 558 + y, 349 + x, 559 + y) // 左下
  ctx.quadraticCurveTo(358 + x, 552 + y, 401 + x, 563 + y) // 右下
  ctx.quadraticCurveTo(401 + x, 547 + y, 401 + x, 547 + y) // 右脇下
  ctx.quadraticCurveTo(405 + x, 545 + y, 415 + x, 546 + y) // 右袖外下
  ctx.quadraticCurveTo(412 + x, 530 + y, 406 + x, 530 + y) // 右上
  ctx.quadraticCurveTo(404 + x, 524 + y, 404 + x, 524 + y) // 右上2
  ctx.quadraticCurveTo(377 + x, 555 + y, 343 + x, 541 + y) //
  ctx.fill()
  ctx.moveTo(348 + x, 543 + y) //
  ctx.quadraticCurveTo(347 + x, 550 + y, 347 + x, 550 + y) //
  ctx.moveTo(397 + x, 542 + y) //
  ctx.quadraticCurveTo(400 + x, 541 + y, 400 + x, 547 + y) //
  ctx.stroke()
  ctx.closePath()
  // ctx.restore()
}

const gorillaLabelRightArm = (ctx: CanvasRenderingContext2D, x: number, y: number): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#363636'
  // 腕部
  ctx.fillStyle = '#5F4137'
  ctx.beginPath()
  ctx.moveTo(316 + x, 542 + y) //
  ctx.quadraticCurveTo(320 + x, 557 + y, 328 + x, 560 + y) //
  ctx.quadraticCurveTo(332 + x, 564 + y, 340 + x, 560 + y) //
  ctx.quadraticCurveTo(345 + x, 559 + y, 348 + x, 556 + y) // 袖右下
  ctx.quadraticCurveTo(347 + x, 546 + y, 341 + x, 544 + y) // 袖左上
  ctx.quadraticCurveTo(339 + x, 547 + y, 339 + x, 547 + y) //
  ctx.quadraticCurveTo(336 + x, 540 + y, 337 + x, 537 + y) //
  ctx.quadraticCurveTo(316 + x, 542 + y, 316 + x, 542 + y) //
  ctx.stroke()
  ctx.fill()
  ctx.closePath()
  // 手のひら
  ctx.strokeStyle = '#363636'
  ctx.fillStyle = '#FFAC76'
  ctx.beginPath()
  ctx.moveTo(317 + x, 532 + y) // 左上
  ctx.quadraticCurveTo(326 + x, 534 + y, 322 + x, 539 + y) // 小指先端
  ctx.quadraticCurveTo(317 + x, 538 + y, 316 + x, 542 + y) //
  ctx.quadraticCurveTo(322 + x, 550 + y, 331 + x, 540 + y) //
  ctx.quadraticCurveTo(333 + x, 545 + y, 337 + x, 537 + y) //
  ctx.quadraticCurveTo(340 + x, 532 + y, 336 + x, 532 + y) //
  ctx.quadraticCurveTo(336 + x, 525 + y, 331 + x, 525 + y) // 右上
  ctx.quadraticCurveTo(327 + x, 525 + y, 326 + x, 527 + y) //
  ctx.quadraticCurveTo(322 + x, 528 + y, 322 + x, 528 + y) //
  ctx.quadraticCurveTo(317 + x, 528 + y, 317 + x, 532 + y) //
  ctx.fill()
  ctx.moveTo(321 + x, 527 + y) // 左上 _小指
  ctx.quadraticCurveTo(326 + x, 528 + y, 327 + x, 534 + y) //
  ctx.quadraticCurveTo(329 + x, 538 + y, 323 + x, 537 + y) //
  ctx.moveTo(326 + x, 525 + y) // 左上 _中指
  ctx.quadraticCurveTo(331 + x, 527 + y, 332 + x, 534 + y) //
  ctx.quadraticCurveTo(331 + x, 540 + y, 328 + x, 536 + y) //
  ctx.moveTo(336 + x, 531 + y) // 親指
  ctx.quadraticCurveTo(333 + x, 530 + y, 330 + x, 541 + y) //
  ctx.stroke()
  ctx.closePath()
}

const gorillaLabelLeftArm = (ctx: CanvasRenderingContext2D, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#363636'
  // 腕部
  ctx.fillStyle = '#5F4137'
  ctx.beginPath()
  ctx.moveTo(391 + x, 549 + y) // 左上
  ctx.quadraticCurveTo(388 + x, 557 + y, 391 + x, 567 + y) // 左下
  ctx.quadraticCurveTo(408 + x, 574 + y, 413 + x, 563 + y) // 右下
  ctx.quadraticCurveTo(415 + x, 548 + y, 413 + x, 545 + y) // 右上
  ctx.quadraticCurveTo(407 + x, 544 + y, 401 + x, 546 + y) // 左上
  ctx.quadraticCurveTo(401 + x, 550 + y, 401 + x, 550 + y) //
  ctx.quadraticCurveTo(394 + x, 545 + y, 391 + x, 549 + y) //
  ctx.stroke()
  ctx.fill()
  ctx.closePath()
  // 手のひら
  ctx.strokeStyle = '#363636'
  ctx.fillStyle = '#FFAC76'
  ctx.beginPath()
  ctx.moveTo(390 + x, 552 + y) // 右上
  ctx.quadraticCurveTo(382 + x, 547 + y, 377 + x, 552 + y) // 左上
  ctx.quadraticCurveTo(377 + x, 557 + y, 377 + x, 557 + y) //
  ctx.quadraticCurveTo(379 + x, 561 + y, 379 + x, 561 + y) //
  ctx.quadraticCurveTo(378 + x, 567 + y, 386 + x, 564 + y) //
  ctx.quadraticCurveTo(390 + x, 567 + y, 390 + x, 567 + y) //
  ctx.quadraticCurveTo(388 + x, 555 + y, 390 + x, 552 + y) //
  ctx.fill()
  ctx.moveTo(377 + x, 557 + y) // 左上 _小指
  ctx.quadraticCurveTo(380 + x, 553 + y, 384 + x, 554 + y) //
  ctx.moveTo(379 + x, 562 + y) // 左上 _中指
  ctx.quadraticCurveTo(380 + x, 557 + y, 385 + x, 559 + y) //
  ctx.stroke()
  ctx.closePath()
  // バナナ＿実
  ctx.strokeStyle = '#363636'
  ctx.fillStyle = '#FDFF00'
  ctx.beginPath()
  ctx.moveTo(387 + x, 532 + y) // 上
  ctx.quadraticCurveTo(382 + x, 535 + y, 381 + x, 549 + y) // 左下
  ctx.quadraticCurveTo(384 + x, 546 + y, 388 + x, 546 + y) // 右下
  ctx.quadraticCurveTo(388 + x, 535 + y, 389 + x, 532 + y) // 右上
  ctx.quadraticCurveTo(388 + x, 530 + y, 387 + x, 532 + y) // 上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // バナナ＿皮1
  ctx.strokeStyle = '#363636'
  ctx.fillStyle = '#FFD700'
  ctx.beginPath()
  ctx.moveTo(380 + x, 544 + y) // 上
  ctx.quadraticCurveTo(368 + x, 548 + y, 371 + x, 558 + y) // 左下
  ctx.quadraticCurveTo(373 + x, 551 + y, 381 + x, 550 + y) // 右下
  ctx.quadraticCurveTo(378 + x, 545 + y, 380 + x, 544 + y) //
  ctx.fill()
  ctx.moveTo(370 + x, 552 + y) // 上
  ctx.quadraticCurveTo(379 + x, 545 + y, 379 + x, 548 + y) // 左下
  ctx.stroke()
  ctx.closePath()
  // バナナ＿皮2
  ctx.beginPath()
  ctx.moveTo(381 + x, 550 + y) // 上
  ctx.quadraticCurveTo(392 + x, 547 + y, 393 + x, 563 + y) // 下
  ctx.quadraticCurveTo(399 + x, 556 + y, 395 + x, 547 + y) //
  ctx.quadraticCurveTo(388 + x, 544 + y, 388 + x, 548 + y) //
  ctx.quadraticCurveTo(383 + x, 545 + y, 381 + x, 550 + y) //
  ctx.fill()
  ctx.moveTo(387 + x, 548 + y) // 上
  ctx.quadraticCurveTo(393 + x, 546 + y, 396 + x, 558 + y) // 下
  ctx.stroke()
  ctx.closePath()
}

const gorillaLabelLowerBody = (ctx: CanvasRenderingContext2D, x: number, y: number): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#363636'
  // 脚部
  ctx.fillStyle = '#5F4137'
  ctx.beginPath()
  ctx.moveTo(334 + x, 563 + y) // 左上
  ctx.quadraticCurveTo(340 + x, 580 + y, 340 + x, 582 + y) // 左下
  ctx.quadraticCurveTo(350 + x, 578 + y, 365 + x, 580 + y) //
  ctx.quadraticCurveTo(375 + x, 583 + y, 375 + x, 583 + y) //
  ctx.quadraticCurveTo(382 + x, 578 + y, 392 + x, 582 + y) //
  ctx.quadraticCurveTo(411 + x, 585 + y, 410 + x, 566 + y) //
  ctx.quadraticCurveTo(364 + x, 551 + y, 348 + x, 558 + y) //
  ctx.quadraticCurveTo(355 + x, 563 + y, 355 + x, 563 + y) //
  ctx.quadraticCurveTo(342 + x, 557 + y, 334 + x, 563 + y) //
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  // 右足のひら＿
  ctx.strokeStyle = '#363636'
  ctx.fillStyle = '#FFAC76'
  ctx.beginPath()
  ctx.moveTo(320 + x, 565 + y) // 右上
  ctx.quadraticCurveTo(317 + x, 568 + y, 324 + x, 570 + y) // 左上
  ctx.quadraticCurveTo(330 + x, 578 + y, 330 + x, 578 + y) //
  ctx.quadraticCurveTo(327 + x, 583 + y, 335 + x, 585 + y) //
  ctx.quadraticCurveTo(343 + x, 585 + y, 338 + x, 575 + y) //
  ctx.quadraticCurveTo(334 + x, 565 + y, 334 + x, 565 + y) //
  ctx.quadraticCurveTo(334 + x, 560 + y, 334 + x, 560 + y) // 右上
  ctx.quadraticCurveTo(330 + x, 557 + y, 328 + x, 560 + y) //
  ctx.quadraticCurveTo(322 + x, 560 + y, 320 + x, 565 + y) //
  ctx.fill()
  ctx.moveTo(331 + x, 560 + y) //
  ctx.quadraticCurveTo(327 + x, 563 + y, 331 + x, 567 + y) //
  ctx.moveTo(324 + x, 561 + y) //
  ctx.quadraticCurveTo(324 + x, 563 + y, 327 + x, 566 + y) //
  ctx.moveTo(321 + x, 563 + y) //
  ctx.quadraticCurveTo(325 + x, 568 + y, 325 + x, 568 + y) //
  ctx.stroke()
  ctx.closePath()

  // 左足のひら＿
  ctx.strokeStyle = '#363636'
  ctx.fillStyle = '#FFAC76'
  ctx.beginPath()
  ctx.moveTo(363 + x, 559 + y) // 右上
  ctx.quadraticCurveTo(358 + x, 558 + y, 361 + x, 566 + y) //
  ctx.quadraticCurveTo(364 + x, 573 + y, 366 + x, 577 + y) //
  ctx.quadraticCurveTo(364 + x, 578 + y, 367 + x, 584 + y) //
  ctx.quadraticCurveTo(374 + x, 588 + y, 376 + x, 581 + y) //
  ctx.quadraticCurveTo(378 + x, 568 + y, 376 + x, 567 + y) //
  ctx.quadraticCurveTo(378 + x, 564 + y, 376 + x, 561 + y) //
  ctx.quadraticCurveTo(363 + x, 559 + y, 363 + x, 559 + y) //
  ctx.fill()
  ctx.moveTo(364 + x, 558 + y) //
  ctx.quadraticCurveTo(364 + x, 560 + y, 366 + x, 567 + y) //
  ctx.moveTo(368 + x, 560 + y) //
  ctx.quadraticCurveTo(368 + x, 560 + y, 370 + x, 567 + y) //
  ctx.moveTo(372 + x, 560 + y) //
  ctx.quadraticCurveTo(372 + x, 560 + y, 373 + x, 567 + y) //
  ctx.stroke()
  ctx.closePath()
}

const gorillaLabelBatAndGlove = (ctx: CanvasRenderingContext2D, x: number, y: number): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#363636'
  // バット
  ctx.fillStyle = '#BD8522'
  ctx.beginPath()
  ctx.moveTo(311 + x, 532 + y) // 左上
  ctx.quadraticCurveTo(301 + x, 543 + y, 315 + x, 545 + y) // 左下
  ctx.quadraticCurveTo(340 + x, 532 + y, 340 + x, 532 + y) //
  ctx.quadraticCurveTo(421 + x, 508 + y, 421 + x, 508 + y) //
  ctx.quadraticCurveTo(426 + x, 504 + y, 424 + x, 498 + y) // ヘッド右
  ctx.quadraticCurveTo(422 + x, 494 + y, 418 + x, 495 + y) // ヘッド左
  ctx.quadraticCurveTo(321 + x, 533 + y, 321 + x, 533 + y) //
  ctx.quadraticCurveTo(317 + x, 534 + y, 311 + x, 532 + y) //
  ctx.fill()
  ctx.moveTo(310 + x, 535 + y) // 左上
  ctx.quadraticCurveTo(318 + x, 545 + y, 309 + x, 543 + y) // 左下
  ctx.stroke()
  ctx.closePath()

  // グローブ
  ctx.strokeStyle = '#363636'
  ctx.fillStyle = '#632300'
  ctx.beginPath()
  ctx.moveTo(405 + x, 498 + y) // 上
  ctx.quadraticCurveTo(414 + x, 501 + y, 414 + x, 509 + y) //
  ctx.quadraticCurveTo(401 + x, 513 + y, 401 + x, 513 + y) // 左
  ctx.quadraticCurveTo(398 + x, 516 + y, 404 + x, 518 + y) // 左
  ctx.quadraticCurveTo(408 + x, 528 + y, 411 + x, 522 + y) //
  ctx.quadraticCurveTo(415 + x, 530 + y, 418 + x, 524 + y) //
  ctx.quadraticCurveTo(424 + x, 530 + y, 426 + x, 523 + y) //
  ctx.quadraticCurveTo(421 + x, 517 + y, 426 + x, 505 + y) //
  ctx.quadraticCurveTo(424 + x, 503 + y, 424 + x, 503 + y) //
  ctx.quadraticCurveTo(423 + x, 506 + y, 420 + x, 507 + y) //
  ctx.quadraticCurveTo(417 + x, 492 + y, 405 + x, 498 + y) //
  ctx.fill()
  ctx.moveTo(414 + x, 508 + y) //
  ctx.quadraticCurveTo(419 + x, 515 + y, 420 + x, 506 + y) //
  ctx.moveTo(404 + x, 512 + y) //
  ctx.quadraticCurveTo(403 + x, 515 + y, 404 + x, 518 + y) //
  ctx.moveTo(409 + x, 514 + y) //
  ctx.quadraticCurveTo(408 + x, 519 + y, 411 + x, 523 + y) //
  ctx.moveTo(417 + x, 515 + y) //
  ctx.quadraticCurveTo(415 + x, 518 + y, 418 + x, 523 + y) //
  ctx.stroke()
  ctx.closePath()
}

export const gorillaLabelOverAll = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  headX: number,
  headY: number,
  numerator: number,
  scaleSize: number
): void => {
  ctx.save()
  ctx.rotate((numerator * Math.PI) / 180)
  ctx.scale(scaleSize, scaleSize)
  gorillaLabelBatAndGlove(ctx, x, y)
  gorillaLabelLowerBody(ctx, x, y)
  gorillaLabelRightArm(ctx, x, y)
  gorillaLabelBody(ctx, x, y)
  gorillaLabelHead(ctx, 297 + headX, 390 + headY, 0, 0.56)
  gorillaLabelLeftArm(ctx, x, y)
  ctx.restore()
}

export const gorillaLabelOverAllWithBanana = (ctx: CanvasRenderingContext2D, x: number, y: number): void => {
  const img = new Image()
  img.src = '/gorilla/labels/gorillaLabelWithBanana.png'
  img.onload = () => {
    ctx.drawImage(img, 360 + x, 495 + y, 120, 85)
  }
}

export const gorillaLabelGold = (ctx: CanvasRenderingContext2D, x: number, y: number): void => {
  const img = new Image()
  img.src = '/gorilla/labels/gorillaLabelGold.png'
  img.onload = () => {
    ctx.drawImage(img, 350 + x, 490 + y, 140, 100)
  }
}

// 捕球面の刻印
export const gorillaEngravedOfCatchFace = (ctx: CanvasRenderingContext2D, catchFaceColor: string, x: number, y: number): void => {
  ctx.lineWidth = 1.5
  const isBright = [
    'black',
    'kBlack',
    'uBlack',
    'jBlack',
    'navy',
    'blue',
    'red',
    'cork',
    'purple',
    'chocolate',
    'mardiGras',
    'pink',
    'tealGreen',
    'gray'
    // 'silver'
  ].includes(catchFaceColor)
  ctx.strokeStyle = isBright ? '#eee' : '#6d6d6d'
  ctx.beginPath()
  ctx.font = '10px serif'
  ctx.strokeText(`GORILLA BASEBALL`, 430 + x, 420 + y)
  ctx.font = '16px serif'
  ctx.strokeText(`CREATE POSSIBILITY`, 395 + x, 445 + y)
  ctx.stroke()
  ctx.closePath()
}

const brightChecker = (leatherColor: string) => {
  const isBright = [
    'black',
    'kBlack',
    'uBlack',
    'jBlack',
    'navy',
    'blue',
    'red',
    'cork',
    'purple',
    'chocolate',
    'mardiGras',
    'pink',
    'tealGreen',
    'gray'
    // 'silver'
  ].includes(leatherColor)
  return isBright
}

export const gorillaEngravedOfBackBand = (ctx: CanvasRenderingContext2D, backFaceColor: string, x: number, y: number): void => {
  const isBright = brightChecker(backFaceColor)
  ctx.strokeStyle = isBright ? '#eee' : '#6d6d6d'
  ctx.beginPath()
  ctx.font = 'bold 18px sans-serif'
  ctx.strokeText(`GORILLA`, 215 + x, 565 + y)
  ctx.stroke()
  ctx.closePath()
}

export const gorillaEngravedOfBackThumb = (ctx: CanvasRenderingContext2D, backFaceColor: string, x: number, y: number): void => {
  const isBright = brightChecker(backFaceColor)
  ctx.save()
  ctx.rotate((-55 * Math.PI) / 180)
  ctx.strokeStyle = isBright ? '#eee' : '#6d6d6d'
  ctx.font = 'bold 18px sans-serif'
  ctx.beginPath()
  ctx.strokeText(`GORILLA`, -40 + x, 745 + y)
  ctx.stroke()
  ctx.closePath()
  ctx.restore()
}

export const gorillaEngravedOfBackThumbLeftThrow = (ctx: CanvasRenderingContext2D, backFaceColor: string, x: number, y: number): void => {
  const isBright = brightChecker(backFaceColor)
  ctx.save()
  ctx.rotate((55 * Math.PI) / 180)
  ctx.strokeStyle = isBright ? '#eee' : '#6d6d6d'
  ctx.font = 'bold 18px sans-serif'
  ctx.beginPath()
  ctx.strokeText(`GORILLA`, 460 + x, 25 + y)
  ctx.stroke()
  ctx.closePath()
  ctx.restore()
}

export const gorillaEngravedOfBackPinkey = (ctx: CanvasRenderingContext2D, backFaceColor: string, x: number, y: number): void => {
  const isBright = brightChecker(backFaceColor)
  ctx.save()
  ctx.rotate((85 * Math.PI) / 180)
  ctx.strokeStyle = isBright ? '#eee' : '#6d6d6d'
  ctx.font = 'bold 18px sans-serif'
  ctx.beginPath()
  ctx.strokeText(`GORILLA`, 300 + x, -185 + y)
  ctx.stroke()
  ctx.closePath()
  ctx.restore()
}

export const gorillaEngravedOfBackPinkeyLeftThrow = (ctx: CanvasRenderingContext2D, backFaceColor: string, x: number, y: number): void => {
  const isBright = brightChecker(backFaceColor)
  ctx.save()
  ctx.rotate((-85 * Math.PI) / 180)
  ctx.strokeStyle = isBright ? '#eee' : '#6d6d6d'
  ctx.font = 'bold 18px sans-serif'
  ctx.beginPath()
  ctx.strokeText(`GORILLA`, -300 + x, 690 + y)
  ctx.stroke()
  ctx.closePath()
  ctx.restore()
}
